module.exports = __webpack_public_path__ + "img/12.1-gallery.df9518a6.jpg";